import type { PropsWithChildren } from 'react'
import { useSsrRoutingContext } from 'lib/routing/ssrRoutingContext'

interface Props {
  code: number
}

function HttpStatus({ code, children }: PropsWithChildren<Props>) {
  const ssrRoutingContext = useSsrRoutingContext()

  if (ssrRoutingContext) {
    ssrRoutingContext.statusCode = code
  }

  return children
}

export default HttpStatus
